/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ q: NonNullable<unknown> }} Exercise_Search_TermInputs */

const en_us2_exercise_search_term = /** @type {(inputs: Exercise_Search_TermInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`“${i?.q}”`)
};

const pt_br2_exercise_search_term = /** @type {(inputs: Exercise_Search_TermInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`“${i?.q}”`)
};

const es_419_exercise_search_term = /** @type {(inputs: Exercise_Search_TermInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`“${i?.q}”`)
};

const pt_pt2_exercise_search_term = /** @type {(inputs: Exercise_Search_TermInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`“${i?.q}”`)
};

const fr_fr2_exercise_search_term = /** @type {(inputs: Exercise_Search_TermInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`« ${i?.q} »`)
};

const de_de2_exercise_search_term = /** @type {(inputs: Exercise_Search_TermInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`„${i?.q}“`)
};

const it_it2_exercise_search_term = /** @type {(inputs: Exercise_Search_TermInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`“${i?.q}”`)
};

/**
* | output |
* | --- |
* | "“{q}”" |
*
* @param {Exercise_Search_TermInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_search_term = /** @type {((inputs: Exercise_Search_TermInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Search_TermInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_search_term(inputs)
	if (locale === "es-419") return es_419_exercise_search_term(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_search_term(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_search_term(inputs)
	if (locale === "de-DE") return de_de2_exercise_search_term(inputs)
	if (locale === "it-IT") return it_it2_exercise_search_term(inputs)
	return en_us2_exercise_search_term(inputs)
});
export { exercise_search_term as "exercise.search_term" }